import {
    DEBUG_ENABLED,
    DEBUG_DISABLED,
    DEBUG_INFO_ENABLED,
    DEBUG_INFO_DISABLED,
    SET_SURVEY_MODE,
    SET_DISPLAY_IN_THEME_EDITOR,
    HIDE_ACCESSIBILITY_PANEL,
} from "../actions";
import { ApplicationState } from "../../models/states/ApplicationState";
import { SurveyMode } from "../../models/enums/SurveyMode";
import { ActionTypes } from "../actions/types";

const INITIAL_STATE: ApplicationState = {
    debug: false,
    mode: SurveyMode.Normal,
    debugInfo: false,
    displayInThemeEditor: false,
    hideAccessibilityPanel: true,
};

export const applicationReducer = (state = INITIAL_STATE, action: ActionTypes) => {
    switch (action.type) {
        case DEBUG_ENABLED:
            return { ...state, debug: true };
        case DEBUG_DISABLED:
            return { ...state, debug: false };
        case SET_SURVEY_MODE:
            return { ...state, mode: action.mode };
        case DEBUG_INFO_ENABLED:
            return { ...state, debugInfo: true };
        case DEBUG_INFO_DISABLED:
            return { ...state, debugInfo: false };
        case SET_DISPLAY_IN_THEME_EDITOR:
            return { ...state, displayInThemeEditor: action.displayInThemeEditor };
        case HIDE_ACCESSIBILITY_PANEL:
            return { ...state, hideAccessibilityPanel: action.hideAccessibilityPanel };
        default:
            return state;
    }
};
